module.exports = __webpack_public_path__ + "static/projektowanie-etykiet-kolory-f498bfb5199f1a71459584e8d1adebff.png";